import AboutUsPage from "../pages/AboutUsPage";
import BlogsPage from "../pages/Blogs";
import CloudMembershipPage from "../pages/CloudMembershipPage";
import ContactUsPage from "../pages/ContactUsPage";
import HomePage from "../pages/HomePage";
import OurGlobalImpactPage from "../pages/OurGlobalImpactPage";
import PortfolioPage from "../pages/PortfolioPage";
import ServiceDetailsPage from "../pages/ServiceDetailsPage";
import BlogsDetailsPage from "../pages/BlogsDetailsPage";
import RolesPage from "../pages/RolesPage";
import TeamDetails from "../components/TeamDetails";
import LoginPage from "../pages/auth/Login";
import RegisterPage from "../pages/auth/Register";
import MainDeshboard from "../pages/admin_pannel/MainDeshboard";

const routes = {
  public: [
    { path: "/", element: HomePage },
    { path: "/login", element: LoginPage },
    { path: "/register", element: RegisterPage },
    { path: "/serviceDetails", element: ServiceDetailsPage },
    { path: "/blogs/Details", element: BlogsDetailsPage },
    { path: "/blogs/Details/:blogId", element: BlogsDetailsPage },
    { path: "/portfolio", element: PortfolioPage },
    { path: "/aboutUs", element: AboutUsPage },
    { path: "/ourGlobalImpact", element: OurGlobalImpactPage },
    { path: "/contactUs", element: ContactUsPage },
    { path: "/blogs", element: BlogsPage },
    { path: "/cloudMembership", element: CloudMembershipPage },
    { path: "/roles", element: RolesPage },
    { path: "/team-details/:roleId", element: TeamDetails },
  ],
  dashboard: [
    // { path: "/maindashboard", element: MainDashboard },
  ],
  admin: [
    { path: "/admin", element: MainDeshboard },
  ],
};

export default routes;
